module.exports = __webpack_public_path__ + "static/media/natural-stone-black.2315f75c.svg";